import { useState } from "react";
import { MapPin, Mail, Clock, MessageCircle, Star, ArrowUpRight } from "lucide-react";
import { FORMULES, SITE } from "../../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Contact = () => {
  const [form, setForm] = useState({ nom: "", tel: "", formule: FORMULES[1].name, message: "" });

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const text = `Bonjour Bestconduite78 !\n\nJe m'appelle ${form.nom}.\nFormule souhaitée : ${form.formule}\n${form.message ? `Message : ${form.message}\n` : ""}\nMon numéro : ${form.tel}\n\nJe souhaite prendre rendez-vous. Merci !`;
    window.open(`https://wa.me/${SITE.phoneIntl}?text=${encodeURIComponent(text)}`, "_blank", "noopener");
  };

  const inputCls =
    "w-full rounded-xl border border-slate-200 bg-white px-4 py-3.5 text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-shadow duration-200";

  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="glow-blob absolute -top-20 -right-32 w-[460px] h-[460px] rounded-full bg-violet-200/45" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          label="Contact & rendez-vous"
          title="Passez nous voir à Chatou"
          description="Une question, un devis, une inscription ? Écrivez-nous : votre message arrive directement sur notre WhatsApp, nous vous répondons en général dans l'heure."
        />

        <div className="grid lg:grid-cols-5 gap-8 mt-14">
          <Reveal className="lg:col-span-3">
            <form
              onSubmit={submit}
              data-testid="contact-form"
              className="rounded-2xl bg-white border border-slate-100 shadow-[0_16px_50px_rgb(0,0,0,0.06)] p-7 sm:p-9"
            >
              <div className="grid sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="contact-nom" className="block text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                    Nom complet
                  </label>
                  <input
                    id="contact-nom"
                    data-testid="contact-input-nom"
                    required
                    value={form.nom}
                    onChange={update("nom")}
                    placeholder="Marie Dupont"
                    className={inputCls}
                  />
                </div>
                <div>
                  <label htmlFor="contact-tel" className="block text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                    Téléphone
                  </label>
                  <input
                    id="contact-tel"
                    data-testid="contact-input-tel"
                    required
                    type="tel"
                    value={form.tel}
                    onChange={update("tel")}
                    placeholder="06 12 34 56 78"
                    className={inputCls}
                  />
                </div>
              </div>
              <div className="mt-5">
                <label htmlFor="contact-formule" className="block text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                  Formule qui vous intéresse
                </label>
                <select
                  id="contact-formule"
                  data-testid="contact-select-formule"
                  value={form.formule}
                  onChange={update("formule")}
                  className={inputCls}
                >
                  {FORMULES.map((f) => (
                    <option key={f.id} value={f.name}>
                      {f.name} — {f.price}
                    </option>
                  ))}
                  <option value="Je ne sais pas encore">Je ne sais pas encore</option>
                </select>
              </div>
              <div className="mt-5">
                <label htmlFor="contact-message" className="block text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
                  Votre message (facultatif)
                </label>
                <textarea
                  id="contact-message"
                  data-testid="contact-textarea-message"
                  rows={4}
                  value={form.message}
                  onChange={update("message")}
                  placeholder="Bonjour, je souhaite des informations sur…"
                  className={`${inputCls} resize-none`}
                />
              </div>
              <button
                type="submit"
                data-testid="contact-submit-button"
                className="btn-shine group mt-7 w-full rounded-full bg-violet-700 text-white font-bold py-4 flex items-center justify-center gap-2.5 hover:bg-violet-800 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-violet-700/25 transition-[transform,background-color,box-shadow] duration-200"
              >
                <MessageCircle size={18} />
                Envoyer via WhatsApp
              </button>
              <p className="text-xs text-slate-400 text-center mt-4">
                En cliquant, WhatsApp s'ouvre avec votre message pré-rempli. Aucune donnée n'est stockée sur ce site.
              </p>
            </form>
          </Reveal>

          <Reveal delay={0.12} className="lg:col-span-2">
            <div className="h-full flex flex-col gap-6">
              <div className="rounded-2xl bg-slate-900 text-white p-7 sm:p-8" data-testid="contact-info-card">
                <h3 className="font-heading font-bold text-lg">Bestconduite78 — Chatou</h3>
                <ul className="mt-5 space-y-4 text-sm">
                  <li className="flex items-start gap-3">
                    <MapPin size={17} className="text-violet-300 mt-0.5 shrink-0" />
                    <span className="text-slate-300" data-testid="contact-address">{SITE.address}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Mail size={17} className="text-violet-300 mt-0.5 shrink-0" />
                    <a href={`mailto:${SITE.email}`} className="text-slate-300 hover:text-white transition-colors" data-testid="contact-email">
                      {SITE.email}
                    </a>
                  </li>
                  <li className="flex items-start gap-3">
                    <Star size={17} className="text-violet-300 mt-0.5 shrink-0" />
                    <a href={SITE.googleUrl} target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors" data-testid="contact-google-link">
                      5/5 sur Google — voir notre fiche
                    </a>
                  </li>
                  <li className="flex items-start gap-3">
                    <Clock size={17} className="text-violet-300 mt-0.5 shrink-0" />
                    <div data-testid="contact-hours">
                      {SITE.hours.map((h) => (
                        <p key={h.days} className="text-slate-300">
                          <span className="text-slate-500">{h.days} :</span> {h.time}
                        </p>
                      ))}
                    </div>
                  </li>
                </ul>
              </div>
              <div className="rounded-2xl overflow-hidden border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.05)] flex-1 min-h-[240px]" data-testid="contact-map">
                <iframe
                  title="Plan d'accès — Auto-école Bestconduite78 à Chatou (78400)"
                  src="https://www.google.com/maps?q=137+Rue+du+G%C3%A9n%C3%A9ral+Leclerc+78400+Chatou&output=embed"
                  className="w-full h-full min-h-[240px] border-0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>
              <a
                href="https://maps.app.goo.gl/mqzrxcHEWakJ8wL59"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-maps-link"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-white border border-slate-200 px-6 py-3 text-sm font-bold text-slate-700 hover:border-violet-400 hover:text-violet-700 hover:-translate-y-0.5 transition-[color,border-color,transform] duration-200 shadow-[0_8px_30px_rgb(0,0,0,0.05)]"
              >
                Ouvrir dans Google Maps
                <ArrowUpRight size={16} />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
